import { CSSProperties, FC } from "react";
import { CalendarItem } from "../types";
import clsx from "clsx";
import "./EventDetails.css";
import {
	extractTextUntilFirstBr,
	getFormattedTimeSpanAndDate,
} from "../helpers";

interface EventDetailsProps {
	event: CalendarItem;
	variant: EventDetailsVariant;
	dayDate: Date;
}

export enum EventDetailsVariant {
	DAY = "day",
	LIST = "list",
	PREVIEW = "preview",
	POPUP = "popup",
}

const EventDetails: FC<EventDetailsProps> = ({ event, variant, dayDate }) => {
	const formattedTimeSpanAndDate = getFormattedTimeSpanAndDate(event, dayDate);
	const eventDetailsStyle = {
		"--accent-color": event.color,
	} as CSSProperties;

	const eventDetailsClasses = clsx("scb-event-details", {
		[`scb-event-details--day`]: variant === EventDetailsVariant.DAY,
		[`scb-event-details--popup`]: variant === EventDetailsVariant.POPUP,
		[`scb-event-details--list`]: variant === EventDetailsVariant.LIST,
	});

	const showVenue =
		variant === EventDetailsVariant.PREVIEW ||
		variant === EventDetailsVariant.POPUP;

	const showLink = variant === EventDetailsVariant.LIST;
	const showButton = variant === EventDetailsVariant.POPUP;
	const showPrerequisite = variant === EventDetailsVariant.POPUP;
	const showTags =
		variant === EventDetailsVariant.POPUP || variant === EventDetailsVariant.LIST;
	const showEventType =
		variant === EventDetailsVariant.POPUP || variant === EventDetailsVariant.LIST;
	const showDayTime =
		variant === EventDetailsVariant.LIST || variant === EventDetailsVariant.POPUP;
	const showSubtitle =
		variant === EventDetailsVariant.LIST ||
		variant === EventDetailsVariant.POPUP ||
		variant === EventDetailsVariant.DAY;
	const customTime = "custom_time" in event.acf ? event.acf.custom_time : false;
	const showTime = variant === EventDetailsVariant.DAY && !customTime;
	return (
		<div
			className={eventDetailsClasses}
			style={eventDetailsStyle}
		>
			<div className="scb-event-details__header">
				{showTime && (
					<div className="scb-event-details__time">
						{formattedTimeSpanAndDate.timeSpan}
						<span className="scb-event-details__uhr">&nbsp;Uhr</span>
					</div>
				)}
				{showDayTime && (
					<div className="scb-event-details__time">
						{formattedTimeSpanAndDate.formattedDate}
						{!customTime && (
							<span>
								{" | " + formattedTimeSpanAndDate.timeSpan}
								<span className="scb-event-details__uhr">&nbsp;Uhr</span>
							</span>
						)}
					</div>
				)}
				{showLink && event.link && (
					<a
						className="scb-event-details__link"
						href={event.link}
					>
						<h3
							className="scb-event-details__heading"
							dangerouslySetInnerHTML={{ __html: event.acf.maintitle }}
						/>{" "}
					</a>
				)}{" "}
				{!showLink && (
					<h3
						className="scb-event-details__heading"
						dangerouslySetInnerHTML={{ __html: event.acf.maintitle }}
					/>
				)}
				{showSubtitle && event.acf.subtitle && (
					<h4
						className="scb-event-details__subtitle"
						dangerouslySetInnerHTML={{ __html: event.acf.subtitle }}
					/>
				)}
				{showEventType && event.event_label && (
					<div className="scb-event-details__label">{event.event_label}</div>
				)}
			</div>
			<div className="scb-event-details__body">
				{showVenue && event.acf.venue && (
					<>
						<h6 className="scb-meta-heading scb-meta-heading--no-margin scb-meta-heading--ort">
							Ort
						</h6>

						<div
							className="scb-event-details__venue"
							dangerouslySetInnerHTML={{
								__html: extractTextUntilFirstBr(event.acf.venue),
							}}
						/>
					</>
				)}
				{showPrerequisite && event.acf.voraussetzungen && (
					<div className="scb-event-details__cell">
						<h6 className="scb-meta-heading">Voraussetzungen</h6>
						<div
							className="scb-event-details__description"
							dangerouslySetInnerHTML={{
								__html: extractTextUntilFirstBr(event.acf.voraussetzungen),
							}}
						/>
					</div>
				)}
				<div className="scb-event-details__footer">
					{showTags && event.dance_tags && event.dance_tags.length > 0 && (
						<div>
							<h6 className="scb-meta-heading scb-meta-heading--kategorien">
								Kategorie(n)
							</h6>
							<div className="scb-event-details__tags">
								{event.dance_tags.map((tag, index) => (
									<span
										className="scb-event-details__tags__item"
										key={index}
									>
										&#x23;{tag}
									</span>
								))}
							</div>
						</div>
					)}
					{showLink && event.link && (
						<a
							className="scb-event-details__link scb-event-details__link--button "
							href={event.link}
						>
							<h6>Details und Anmeldung</h6>
						</a>
					)}
					{showButton && event.link && (
						<a
							className="scb-event-details__link scb-event-details__link--button "
							href={event.link}
						>
							<div className="elementor-button">Details und Anmeldung</div>
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default EventDetails;
